import { render, staticRenderFns } from "./unitreporting.vue?vue&type=template&id=fabf6358&scoped=true&"
import script from "./unitreporting.vue?vue&type=script&lang=js&"
export * from "./unitreporting.vue?vue&type=script&lang=js&"
import style0 from "./unitreporting.vue?vue&type=style&index=0&id=fabf6358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf6358",
  null
  
)

export default component.exports